import * as Proxy from './Proxy'

export default (function () {
    const baseUrl = "/paymentlobby/api/PostAdjustment/";
    return {
        GetPostAdjustmentViewModel(request) {
            var url = baseUrl + "GetPostAdjustmentViewModel";
            return Proxy.Post(url, request);
        },
        SubmitPostAdjustment(request) {
            var url = baseUrl + "SubmitPostAdjustment";
            return Proxy.Post(url, request);
        },
    };
})()